import { useCallback, useState } from "react";
import { apiFetch } from "../api/client";
import { copyTextToClipboard } from "../lib/copyTextToClipboard";
import { useBoardAccess } from "./useBoardAccess";

function cacheKey(boardId: string): string {
  return `wb-board-share-link:v1:${boardId}`;
}

export function useBoardShareLinkCopy(boardId: string, enabled: boolean) {
  const access = useBoardAccess(boardId, enabled);
  const [busy, setBusy] = useState(false);
  const [label, setLabel] = useState<"idle" | "copied" | "error">("idle");

  const canCopy = Boolean(enabled && access.isOwner);

  const copyShareLink = useCallback(async () => {
    if (!canCopy || busy) return;
    setBusy(true);
    setLabel("idle");
    try {
      let url = sessionStorage.getItem(cacheKey(boardId));
      if (!url) {
        const data = await apiFetch<{ shareLink: { openPath?: string } }>(
          `/api/v1/boards/${encodeURIComponent(boardId)}/share-links`,
          { method: "POST", json: { role: "editor" } }
        );
        url = `${window.location.origin}${data.shareLink.openPath || ""}`;
        if (!data.shareLink.openPath) throw new Error("Не удалось создать ссылку");
        sessionStorage.setItem(cacheKey(boardId), url);
        void access.reload();
      }
      await copyTextToClipboard(url);
      setLabel("copied");
      window.setTimeout(() => setLabel("idle"), 2000);
    } catch {
      setLabel("error");
      window.setTimeout(() => setLabel("idle"), 2500);
    } finally {
      setBusy(false);
    }
  }, [access, boardId, busy, canCopy]);

  const text =
    label === "copied" ? "✓ Скопировано" : label === "error" ? "Не удалось" : busy ? "…" : "Ссылка";

  return { canCopy, busy, label, text, copyShareLink };
}
